import PublicHolidayListResourcePagingResultModel from '../../generated/types/model/resource/PublicHolidayListResourcePagingResultModel';

export default class PublicHolidayListResourcePagingResultViewModel extends PublicHolidayListResourcePagingResultModel {
  // For instructions on how to use ViewModels visit: 
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
